import { getShortAddr } from 'modules/common/utils/getShortAddr';

export const ShortenedAddress = ({
  address,
  length,
}: {
  address: string;
  length?: number;
}) => {
  return <span>{getShortAddr(address, length)}</span>;
};
